export default "__VITE_ASSET__DZJ1joss__"